import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2fa7fe2a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "modal-content1"
};
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"drawing-animation\" data-v-2fa7fe2a><svg viewBox=\"0 0 200 150\" class=\"svg-element\" data-v-2fa7fe2a><g class=\"pencil\" transform=\"rotate(-10)\" data-v-2fa7fe2a><path d=\"M158.3,42.3l-11.3,11.3l-28-28l11.3-11.3c2.3-2.3,6.1-2.3,8.5,0l19.5,19.5C160.6,36.2,160.6,40,158.3,42.3z\" fill=\"#FFD972\" data-v-2fa7fe2a></path><path d=\"M119,53.7l-71.8,71.8c-1.2,1.2-3.1,1.2-4.2,0l-11.3-11.3c-1.2-1.2-1.2-3.1,0-4.2L103.5,38L119,53.7z\" fill=\"#F2C43D\" data-v-2fa7fe2a></path><path d=\"M119,53.7l11.3,11.3l-28,28L91,81.7L119,53.7z\" fill=\"#6C412C\" data-v-2fa7fe2a></path><path d=\"M31.7,111.2l-4.2,15.6c-0.3,1,0.1,2.1,0.9,2.8c0.8,0.8,1.8,1.2,2.8,0.9l15.6-4.2L31.7,111.2z\" fill=\"#A58A77\" data-v-2fa7fe2a></path></g><path class=\"line\" fill=\"none\" stroke=\"#A78BFA\" stroke-width=\"6\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M36,133.2c16.4-1.3,31.3-11.8,47-11.2s28.3,16.3,45.3,14.2c17.1-2.1,28.9-19.4,46.7-21.2\" data-v-2fa7fe2a></path></svg></div>", 1);
const _hoisted_3 = [_hoisted_2];
import { ref, onMounted, onUnmounted } from 'vue';
export default {
  __name: 'dawa',
  emits: ["qwbelq"],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    // --- 响应式状态定义 ---
    // 模态框中的主标题
    const mainTitle = ref('');
    // 模态框中的状态文本
    const statusText = ref('');
    // 进度条的宽度，用于 :style 绑定
    const progressBarWidth = ref('0%');
    // 进度条的颜色，用于 :style 绑定
    const progressBarColor = ref('#a78bfa');

    // --- 内部逻辑变量 ---

    // 用于存储 setInterval 的 ID，以便后续清除
    let progressInterval = null;
    // 用于存储 setTimeout 的 ID，以便后续清除
    let completionTimeout = null;
    function updateProgress(fakeProgressRef, messageStageRef) {
      // 不同进度阶段显示的文案
      const messages_stage1 = [{
        title: '数据准备中...',
        status: '正在分析您的请求...'
      }, {
        title: 'AI 正在热身...',
        status: '正在连接 AI 大脑...'
      }];
      const messages_stage2 = [{
        title: '魔法正在发生...',
        status: '灵感马上就来，请保持期待！'
      }];
      const messages_stage3 = [{
        title: '快完成了...',
        status: '正在进行最后的打磨...'
      }, {
        title: '即将完成！',
        status: '正在为您打包这份惊喜...'
      }];
      let currentMessages;
      let newStage = 0;

      // 根据进度决定当前所处的阶段
      if (fakeProgressRef.value < 30) {
        currentMessages = messages_stage1;
        newStage = 1;
      } else if (fakeProgressRef.value < 85) {
        currentMessages = messages_stage2;
        newStage = 2;
      } else {
        currentMessages = messages_stage3;
        newStage = 3;
      }

      // 如果进入了新的阶段，就从该阶段的文案库中随机选择一条来更新 UI
      if (newStage !== messageStageRef.value) {
        messageStageRef.value = newStage;
        const randomIndex = Math.floor(Math.random() * currentMessages.length);
        const selectedMessage = currentMessages[randomIndex];
        mainTitle.value = selectedMessage.title; //大字
        statusText.value = selectedMessage.status; //小字
      }
    }

    // --- 生命周期钩子 ---

    // onMounted 会在组件挂载到 DOM 后执行
    onMounted(() => {
      // 2. 初始化内部状态变量
      let fakeProgress = ref(0);
      let messageStage = ref(0);

      // 3. 重置 UI 状态
      progressBarWidth.value = '0%';
      progressBarColor.value = '#a78bfa';
      mainTitle.value = '收到请求！';
      statusText.value = '请稍候，AI 正在初始化...';

      // 4. 启动一个定时器，每 500 毫秒更新一次进度条和文本
      progressInterval = setInterval(() => {
        updateProgress(fakeProgress, messageStage);
      }, 2000);
    });

    // onUnmounted 会在组件销毁前执行
    onUnmounted(() => {
      // 这是个好习惯：在组件销毁时，清除所有正在运行的定时器，防止内存泄漏。
      if (progressInterval) {
        clearInterval(progressInterval);
      }
      if (completionTimeout) {
        clearTimeout(completionTimeout);
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3);
    };
  }
};